import { parse } from 'yaml'

export default function getValidSpec(spec: Record<string, unknown> | string) {
  if (typeof spec === 'string') {
    try {
      return JSON.parse(spec)
    } catch (error) {
      console.error('Invalid JSON string:', error)
    }
    try {
      return parse(spec)
    } catch (error) {
      console.error('Invalid YAML string:', error)
      throw new Error('Spec must be a string or an object')
    }
  }
  return spec
}
if (import.meta.vitest) {
  const { it, expect } = import.meta.vitest
  it('should parse YAML if is string', () => {
    expect(getValidSpec('key: value')).toEqual({ key: 'value' })
  })
  it('should parse JSON if is string', () => {
    expect(getValidSpec('{"json":"value"}')).toEqual({ json: 'value' })
  })
  it('should throw if the string is not valid JSON or YAML', () => {
    expect(() =>
      getValidSpec("hello: 'worl")
    ).toThrowErrorMatchingInlineSnapshot(
      `[Error: Spec must be a string or an object]`
    )
  })
  it('should return objects as-is', () => {
    expect(getValidSpec({ foo: 'bar' })).toEqual({ foo: 'bar' })
  })
}
